import { TypedUseSelectorHook, useSelector } from "react-redux";

import { ReduxState } from "../lib/state/store";

export const useAppState: TypedUseSelectorHook<ReduxState> = useSelector;
